// extracted by mini-css-extract-plugin
module.exports = {"allArticles":"StyledButton-module--allArticles--3AQXo"};